import SwivuTabBase from "../base/SwivuTabBase.jsx";

export default class ClientsEditorBase extends SwivuTabBase {
  static get $name() {
    return "ClientsEditorBase";
  }

  // Factoryable type name
  static get type() {
    return "clientseditorbasev2";
  }
  static get configurable() {
    return {
      autoUpdateRecord: true
    };
  }

  editRecord(record, context, otherParams) {
    this.loading = true;
    this.loadRecord(record, context, otherParams);
    this.loading = false;
  }

  loadRecord(record, context, otherParams) {
    this.record = record;
    this.context = context;
    this.otherParams = otherParams;
    Object.assign(this, context);
    this.swivuCheckGrants(context.user)
  }

  swivuCheckGrants() {}
}

ClientsEditorBase.initClass();
